<mat-expansion-panel class="activity-history--panel">
    <mat-expansion-panel-header>
      <mat-panel-title>
        Activity History
      </mat-panel-title>
    </mat-expansion-panel-header>
  
    <iaud-table *ngIf="historyTableData"
        [data]="historyTableData" 
        [options]="historyTableOptions" 
        [forceReloadEvent]="forceReloadEvent"
        [dataRefreshCallback]="reloadHistory.bind(this)" >
    </iaud-table>
      
  </mat-expansion-panel>